
import { GroupSchemeScope } from '@/components/mixins/schemescope';
import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { Member } from '@/models/member';

@Component({
  name: 'MoveStayInClassModal',
})
export default class MoveStayInClassModal extends mixins(GroupSchemeScope) {
  @Prop() member!: Member;
  @Prop() private nextLevel!: string;
  @Prop() private moveMember!: () => Promise<void>;
  private processing = false;

  async stayNextLevel() {
    this.processing = true;
    const success = await this.$store.dispatch('groupMembers/markForMove', {
      member: this.member,
      groupId: this.groupId,
      remoteNodeId: this.nextLevel,
      stay: true,
    });
    if (success !== true) {
      this.$alert('error', this.$t('member.move_class_failed'));
    }
    this.member.current_remote_node_id = this.nextLevel;
    this.member.move_remote_node_id = '';
    this.$emit('close');
  }

  get memberName() {
    return `${this.member.firstname} ${this.member.lastname}`;
  }
}
